var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DocumentDeleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J2_Document_deleted_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.3 70.94l-.3.28V76h.33L15 62.25V66h45V24.22l-2-2.13L76 5.32V.2L.3 70.94zM56 62H19v-3.44L25 53v1h16v-4H28.17l4.28-4H50v-4H36.73L41 38h9v-4h-4.71l8.57-8H56v36zM19 48.38l-4 3.7V10h31.88L53 16.63l-8 7.47V14H19v34.38zM25 38v-4h9.4l-4.29 4H25z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "J2_Document_deleted_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/J2_Document_deleted.79791da7.svg";
export { SvgJ2DocumentDeleted as ReactComponent };